import React, { useEffect, useState } from "react";
import {
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import { Droppable } from "./Droppable";
import { Draggable } from "./Draggable";
import Imagen1 from "../images/modulo11/presidenta7.png";
import Imagen2 from "../images/modulo11/congresista7.png";
import Imagen3 from "../images/modulo11/jueza7.png";
import { modulo5 } from "../routes/Module5";

export default function App({ items }) {
  const [showAlert, setShowAlert] = useState(false);

  const containers = ["A", "B", "C"];
  const [parents, setParents] = useState(null);

  useEffect(() => {
    const dragables = items.map((item, idx) => (
      <Draggable id={"item" + (idx + 1)} key={idx} className="bg-white">
        {item}
      </Draggable>
    ));
    setParents({
      item1: { parent: "", content: dragables[0], correctParent: "B", valid: null },
      item2: { parent: "", content: dragables[1], correctParent: "A", valid: null },
      item3: { parent: "", content: dragables[2], correctParent: "C", valid: null  },
    });
  }, [items]);

  const mouseSensor = useSensor(MouseSensor);
  const touchSensor = useSensor(TouchSensor);

  const sensors = useSensors(mouseSensor, touchSensor);
  const validateAnswers = (event) => {
    event.preventDefault();
    let newParents = parents;
    Object.keys(newParents).forEach(
      (key) =>
        (newParents[key]["valid"] =
        parents[key]["correctParent"] ===
        parents[key]["parent"]
            ? 1
            : 0)
    );
    setParents({ ...newParents });
    setShowAlert(true)
  }
  return (
    <div className="">
      {parents ? (
        <DndContext onDragEnd={handleDragEnd} sensors={sensors}>
          <div className="d-flex justify-content-center my-3">
            {Object.keys(parents).map((item, idx) =>
              parents[item].parent === "" ? parents[item].content : null
            )}
          </div>
          <div className="drops-container">
            {parents &&
              containers.map((id, idx) => (
                // We updated the Droppable component so it would accept an `id`
                // prop and pass it to `useDroppable`
                <Droppable key={id} id={id}>
                  <div className="border-2 border rounded shadow-sm p-0 card-book">
                    <div className="mh-100">
                    {Object.keys(parents).map((item, idx) =>
                      parents[item].parent === id ? parents[item].content : null
                    )}
                    </div>
                  
                    </div>
                    {id === "A" ? (
                      <img src={Imagen1} alt="Escuela" className="img-fluid" />
                    ) : null}
                     {id === "B" ? (
                      <img src={Imagen2} alt="Embajada" className="img-fluid" />
                    ) : null}
                     {id === "C" ? (
                      <img src={Imagen3} alt="Comisaria" className="img-fluid" />
                    ) : null}

                   
                </Droppable>
              ))}
          </div>
          <div className="mh-100">
                    {showAlert ? Object.keys(parents).map((item) =>
                      parents[item].valid
                    ).reduce((a,n) => a + n, 0) < 3 ? <div class="alert alert-danger" role="alert">
                    Incorrecto
                  </div> : <div class="alert alert-success" role="alert">
                    Correcto
                  </div>  : null}
                    </div>
        </DndContext>
        
      ) : null}
      
                  
      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo5.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>
    </div>
  );

  function handleDragEnd(event) {
    const { over } = event;
    if (over) {
      const newParent = over.id;
      const item = event.active.id;
      //console.log('item',item );
      //console.log('parents', parents)
      setParents({
        ...parents,
        [item]: { ...parents[item], parent: newParent },
      });
    }

    // If the item is dropped over a container, set it as the parent
    // otherwise reset the parent to `null`
    //setParent(over ? over.id : null);
  }
}
